/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { NotificationActions } from 'app/redux/actions.js';
import * as _ from 'underscore';

function mapStateToProps(state) {
    return({
        notifications: state.notifications
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getNotices: () => {
            dispatch(NotificationActions.fetchNotices());
        },
        clearNotices: (data) => {
            dispatch(NotificationActions.clearNotices(data));
        }
	};
}

export default function NotificationProvider(Component) {

    class NotificationProvider extends React.Component {
        getNoticesForRoute(route) {
    		var notices = [],
    			i = 0;

    		for (i = 0; i < route.inputs.length; ++i) {
    			notices = notices.concat(_.where(this.props.notifications, {entityId: route.inputs[i].id}));
    		}

    		for (i = 0; i < route.outputs.length; ++i) {
    			notices = notices.concat(_.where(this.props.notifications, {entityId: route.outputs[i].social.id}));
    		}

    		return notices;
    	}

    	getDisconnectedSocialNotices() {
    		var notices = [],
    			i = 0,
    			constants = this.props.app.config.constants;

    		notices = _.where(this.props.notifications, {type: constants.NOTICE_TERMINAL.toString(), entityType: 'output'});

    		if (notices === undefined) {
    			return [];
    		}

    		return notices;

    	}

        render() {
            return (
                <Component
                    {...this.props}
                    getNoticesForRoute={this.getNoticesForRoute}
                    getDisconnectedSocialNotices={this.getDisconnectedSocialNotices} />
            );
        }
    }

    NotificationProvider.displayName = "NotificationProvider";

    return connect(mapStateToProps, mapDispatchToProps)(NotificationProvider);
};
